import classNames from 'classnames'
import * as React from 'react'

import Icon from 'components/Icon'
import { Colour } from 'components/variables'
import { UI } from 'Icon/ui'
import AnnouncementPortal from './AnnouncementPortal'

import './Announcement.scss'

export enum AnnouncementType {
  Error = 'error',
  Info = 'info',
  Price = 'price',
  Time = 'time',
  Persuasion = 'persuasion',
}

interface AnnouncementProps {
  icon: JSX.Element
  type: AnnouncementType
  show: boolean
  colour?: Colour
  children?: React.ReactNode | undefined
  onClose(): void
  announcementRef?(ref: HTMLDivElement): void
}

interface AnnouncementState {
  show: boolean
  mounted: boolean
}

class Announcement extends React.Component<
  AnnouncementProps,
  AnnouncementState
> {
  public static defaultProps = { icon: UI.warningRounded }
  private timer: any
  constructor(props: AnnouncementProps) {
    super(props)
    this.state = {
      show: false,
      mounted: false,
    }
  }

  public UNSAFE_componentWillMount() {
    if (this.props.show) {
      this.setState({ mounted: true })
    }
  }

  public UNSAFE_componentWillReceiveProps(props: AnnouncementProps) {
    if (props.show && !this.state.mounted) {
      this.setState({ mounted: true }, () => {
        this.timer = setTimeout(() => {
          this.setState({ show: true })
        }, 100)
      })
    } else if (!props.show && this.state.mounted) {
      this.setState({ show: false }, () => {
        this.timer = setTimeout(() => {
          this.setState({ mounted: false })
        }, 500)
      })
    }
  }

  public componentWillUnmount() {
    clearInterval(this.timer)
  }

  public render() {
    const className = classNames(
      'srprs-announcement',
      `type-${this.props.type.toString()}`,
      this.state.show ? 'show' : '',
      this.props.colour,
    )

    return this.state.mounted ? (
      <AnnouncementPortal>
        <div className={className} ref={this.props.announcementRef}>
          <span className="announcement-icon">
            <Icon icon={this.props.icon} />
          </span>
          <span className="announcement-message">{this.props.children}</span>
          <button className="announcement-close" onClick={this.props.onClose}>
            <Icon icon={UI.close} />
          </button>
        </div>
      </AnnouncementPortal>
    ) : null
  }
}

export default Announcement
